import { STREAMLAIN_NOTE_LAYOUT_READY_ATTR } from '@blocksuite/affine-shared/consts';

export const DATABASE_INITIAL_LOAD_READY_ATTR =
  'data-streamlain-database-initial-load-ready';

export const EDGELESS_NOTE_CONTAINER_SELECTOR =
  '[data-testid="edgeless-note-container"]';

const NOTE_PAGE_CONTENT_SELECTOR = '.edgeless-note-page-content';

const PENDING_NOTE_LAYOUT_SELECTOR = [
  `affine-database:not([${DATABASE_INITIAL_LOAD_READY_ATTR}="true"])`,
  `affine-image:not([${STREAMLAIN_NOTE_LAYOUT_READY_ATTR}="true"])`,
  `[${STREAMLAIN_NOTE_LAYOUT_READY_ATTR}="false"]`,
].join(',');

type NoteLayoutBlockModel = {
  children?: NoteLayoutBlockModel[];
  flavour: string;
  props?: Record<string, unknown>;
};

function isPositiveDimension(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
}

function hasPersistedImageLayout(model: NoteLayoutBlockModel): boolean {
  return (
    isPositiveDimension(model.props?.width) &&
    isPositiveDimension(model.props?.height)
  );
}

function hasPotentialPendingEmbeddedNoteLayoutBlock(
  model: NoteLayoutBlockModel
): boolean {
  if (model.flavour === 'affine:database') {
    return true;
  }

  if (model.flavour === 'affine:image') {
    return !!model.props?.sourceId && !hasPersistedImageLayout(model);
  }

  return (
    model.children?.some(child =>
      hasPotentialPendingEmbeddedNoteLayoutBlock(child)
    ) ?? false
  );
}

export function getEdgelessNoteLayoutContainer(
  root: Element | null
): Element | null {
  if (!root) return null;
  if (root.matches(EDGELESS_NOTE_CONTAINER_SELECTOR)) {
    return root;
  }
  return (
    root.querySelector(EDGELESS_NOTE_CONTAINER_SELECTOR) ??
    root.closest(EDGELESS_NOTE_CONTAINER_SELECTOR)
  );
}

export function hasPendingEmbeddedNoteLayout(root: Element | null): boolean {
  const noteContainer = getEdgelessNoteLayoutContainer(root);
  return !!noteContainer?.querySelector(
    `${NOTE_PAGE_CONTENT_SELECTOR} ${PENDING_NOTE_LAYOUT_SELECTOR}`
  );
}

export function hasPotentialPendingEmbeddedNoteLayoutModel(
  model: NoteLayoutBlockModel | null
): boolean {
  return (
    model?.children?.some(child =>
      hasPotentialPendingEmbeddedNoteLayoutBlock(child)
    ) ?? false
  );
}
